/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OriginInputs */

const en_origin = /** @type {(inputs: OriginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin`)
};

const es_origin = /** @type {(inputs: OriginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origen`)
};

/**
* | output |
* | --- |
* | "Origin" |
*
* @param {OriginInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const origin = /** @type {((inputs?: OriginInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OriginInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_origin(inputs)
	return es_origin(inputs)
});